<div class="my-10 p-10">
  <div class="mt-flex">
    <mt-h4>Please select the file that you want to upload@if (!isTimeline) {
      <b>, ( Allowed extensions are: .xls, .xlsx,
      .csv)</b>
    }.</mt-h4>
  </div>

  <div class="bulk-upload-btn-wrapper">
    <form #uploadExcelForm="ngForm" (ngSubmit)="onUploadFile()">
      <div class="upload-button-custom" for="bulkCallFileID">
        <mt-btn class="nobg white">
          <mat-icon class="mr-5">attachment</mat-icon>
          @if (uploadFileObj && !uploadFileObj.uploadFile) {
            Choose File
          }
          @if (uploadFileObj && uploadFileObj.uploadFile && (uploadFileObj.uploadFile.name)) {
            {{uploadFileObj.uploadFile.name}}
          }
        </mt-btn>
      </div>
      @if (isTimeline) {
        <input required type="file" name="bulkCallFile" [(ngModel)]="uploadFileObj.filename" id="bulkCallFileID"
          class="bulk-upload-input" ngFileSelect (change)="handleFileInput($event)"
          accept=".xls,.xlsx,.pdf,.jpeg,.jpg,.png,.mp3,.gif,.wav,.webm,.mpeg,.csv,.doc,.docx,.mp4,.avi,.mov" />
      }
      @if (!isTimeline) {
        <input required type="file" name="bulkCallFile" [(ngModel)]="uploadFileObj.filename" id="bulkCallFileID"
          class="bulk-upload-input" ngFileSelect (change)="handleFileInput($event)" accept=".xlsx,.csv,.xls" />
      }

      <div class="mt-15 ta-r">
        <mt-btn class="nobg error mr-10" (onAction)="cancelUpload()">Cancel</mt-btn>
        <mt-btn type="submit" [loading]="isLoading" [disabled]="uploadExcelForm.invalid || isUploading">Upload
        </mt-btn>
      </div>
    </form>
  </div>
</div>
